import { MdOutlineBallot } from "react-icons/md";

import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import {
  BiCabinet,
  BiCog,
  BiGridAlt,
  BiGroup,
  BiMapPin,
  BiPound,
  BiPrinter,
  BiPurchaseTag,
  BiSolidDrink,
  BiSubdirectoryRight,
} from "react-icons/bi";

const Menuitems = [
  {
    title: "Items",
    icon: BiSolidDrink,
    href: "/items",
    iconSize: 20,
    dbName: "items",
  },
  {
    title: "Pricing",
    icon: BiPound,
    href: "/pricing",
    iconSize: 20,
    dbName: "pricing",
  },
  {
    title: "Screens",
    icon: BiGridAlt,
    href: "/screens",
    iconSize: 20,
    dbName: "screens",
  },
  {
    title: "Staff",
    icon: BiGroup,
    href: "/staff",
    iconSize: 20,
    dbName: "staff",
  },
  {
    title: "Categories",
    icon: BiCabinet,
    selectedIcon: BiCabinet,
    dropdownIcon: MdOutlineBallot,
    mainTitle: "Categories",
    // subDropdownTitle: "Categories",
    href: "/categoriesmain",
    iconSize: 20,
    dbName: "categoriesMain",
    children: [
      {
        title: "Categories",
        href: "/categories",
        icon: LibraryBooksOutlinedIcon, // updated icon
        iconSize: 25,
        dbName: "categories",
      },
      {
        title: "Major Categories",
        href: "/majorcategories",
        icon: LibraryBooksOutlinedIcon, // updated icon
        iconSize: 25,
        dbName: "major categories",
      },

      // ... add more sub-categories here ...
    ],
  },

  {
    title: "Tags",
    icon: BiPurchaseTag,
    href: "/tags",
    iconSize: 20,
    dbName: "tags",
  },
  {
    title: "Printers",
    icon: BiPrinter,
    href: "/printers",
    dbName: "printers",
    iconSize: 20,
  },
  {
    title: "Sites",
    icon: BiMapPin,
    href: "/sites",
    iconSize: 20,
    dbName: "sites",
  },
  {
    title: "Admin",
    icon: BiCog,
    selectedIcon: BiCog,
    dropdownIcon: MdOutlineBallot,
    mainTitle: "Admin",
    // subDropdownTitle: "Categories",
    admin: true,
    href: "/adminmain",
    iconSize: 20,
    dbName: "admin",
    children: [
      {
        title: "Configuration",
        href: "/configuration",
        icon: BiSubdirectoryRight, // updated icon
        iconSize: 20,
        dbName: "configuration",
      },
      {
        title: "Permissions",
        href: "/permissions",
        icon: BiSubdirectoryRight, // updated icon
        iconSize: 20,
        dbName: "permissions",
      },
      {
        title: "Settings",
        href: "/admin",
        icon: BiSubdirectoryRight, // updated icon
        iconSize: 20,
        dbName: "settings",
      },
      // ... add more sub-categories here ...
    ],
  },
  // {
  // 	title: "Sizes",
  // 	icon: CiRuler,
  // 	href: "/sizes",
  // 	iconSize: 27,
  // },

  // {
  // 	title: "Designer",
  // 	icon: BsGrid1X2,
  // 	href: "/designer",
  // 	iconSize: 22,
  // 	dbName: "list",
  // },

  // {
  // 	title: "DGC Tags",
  // 	icon: AddToPhotosOutlined,
  // 	href: "/dataGridControllerTags",
  // },
  // {
  // 	title: "DGC Items",
  // 	icon: AddToPhotosOutlined,
  // 	href: "/dataGridControllerItems",
  // },
  // {
  // 	title: "DGC Item Types",
  // 	icon: AddToPhotosOutlined,
  // 	href: "/dataGridControllerItemTypes",
  // },
];

export default Menuitems;
